import { useMemo } from 'react'
import { type ReactNode, forwardRef } from 'react'
import { IMaskInput } from 'react-imask'
import tw, { TwStyle } from 'twin.macro'
import { createNumberWithUnitMask } from 'utils/i-masks'

import Typography from '../Typography'

interface InputProps {
  label?: ReactNode
  min?: number
  max?: number
  value: string
  placeholder: string
  isError?: boolean
  containerClassName?: TwStyle
  currency?: string
  inputClassName?: TwStyle
  onAccept?: (value: string) => void
}

const CurrencyInput = forwardRef<HTMLInputElement, InputProps>(
  (
    { label, placeholder, containerClassName, currency = '₸', isError, value, min, max, inputClassName, onAccept },
    ref
  ) => {
    const mask = useMemo(
      () => createNumberWithUnitMask({ min, max, unit: currency, thousandsSeparator: ' ' }),
      [currency, max, min]
    )

    return (
      <div css={[containerClassName]}>
        {label && (
          <Typography variant='caption' className='text-secondary'>
            {label}
          </Typography>
        )}
        <IMaskInput
          value={value}
          inputRef={ref}
          mask={mask}
          placeholder={placeholder}
          unmask
          css={[
            tw`flex h-6 w-full text-base border border-transparent placeholder:text-[#8E8E93] dark:placeholder:text-[#C7C7CC] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50`,
            isError && tw`border-[#DB2547]`,
            inputClassName
          ]}
          onAccept={onAccept} // Event when value is accepted
        />
      </div>
    )
  }
)
CurrencyInput.displayName = 'CurrencyInput'

export default CurrencyInput
